import React from 'react';
import Modal from '../modal/modal';
import Button from '../../UI/button/button';
import styles from './styles.module.scss';

function ModalAlert({ showModal, closeModalFunction, title, content, children }) {
  return (
    <Modal
      modalClass="modal-alert"
      display={showModal}
      closeFunction={closeModalFunction}
      modalContentClass="modal-alert-content"
    >
      <div className="p-4">
        <p className={styles.alertTitle}>{title}</p>

        <div id="alertContent" className={styles.alertContent}>
          {content}
        </div>

        {children}

        <div className="align-center">
          <Button onClick={closeModalFunction} id="btOk">
            OK
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default ModalAlert;
